import { render, staticRenderFns } from "./PriorityDynamics.vue?vue&type=template&id=8869ad1a&"
import script from "./PriorityDynamics.vue?vue&type=script&lang=js&"
export * from "./PriorityDynamics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports